import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from '../../Select';
const getYearsOptions = (min, length) => Array.from({ length }, (_, index) => ({
    value: min + index,
    label: `${min + index}`,
}));
export const YearSelect = React.memo(function YearSelect({ date, changeYear, minYear = new Date().getFullYear() - 4, maxYear = new Date().getFullYear() + 4, }) {
    return (_jsx(Select, { value: { label: `${date.getFullYear()}`, value: date.getFullYear() }, onChange: (option) => option?.value && changeYear(option?.value), options: getYearsOptions(minYear, maxYear - minYear + 1) }));
});
